var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.home === 'easyTermos')?_c('div',[_c('BlogListET')],1):(_vm.home === 'complianceOnline')?_c('div',[_c('BlogListCO')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }